var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_48812)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47964 12.4953C3.27419 12.4973 3.07513 12.5603 2.91297 12.6748C2.75081 12.7892 2.6345 12.9487 2.58187 13.1288C2.52924 13.3089 2.54319 13.4997 2.62159 13.6719C2.69998 13.8442 2.83849 13.9883 3.01589 14.0823L6.32923 15.7858C6.60213 15.9264 6.91073 16.0003 7.22464 16C7.39354 15.9999 7.56153 15.9776 7.72339 15.9339L12.708 14.6457C13.0798 14.5489 13.4068 14.3451 13.6399 14.065C13.8729 13.785 13.9993 13.4439 14.0001 13.0931V12.4953H3.47964Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47964 12.4953C3.27419 12.4973 3.07513 12.5603 2.91297 12.6748C2.75081 12.7892 2.6345 12.9487 2.58187 13.1288C2.52924 13.3089 2.54319 13.4997 2.62159 13.6719C2.69998 13.8442 2.83849 13.9883 3.01589 14.0823L6.32923 15.7858C6.60213 15.9264 6.91073 16.0003 7.22464 16C7.39354 15.9999 7.56153 15.9776 7.72339 15.9339L12.708 14.6457C13.0798 14.5489 13.4068 14.3451 13.6399 14.065C13.8729 13.785 13.9993 13.4439 14.0001 13.0931V12.4953H3.47964Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70288 0.0634842L9.04163 2.8408V12.4953L7.7233 15.9339L12.7079 14.6457C13.0797 14.5489 13.4067 14.3451 13.6398 14.065C13.8728 13.785 13.9992 13.4439 14 13.0931V2.90428C14.0001 2.55256 13.8738 2.21039 13.6401 1.9297C13.4063 1.649 13.078 1.44512 12.705 1.34899L7.70288 0.0634842Z",
    fill: "url(#paint0_linear_1023_48812)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3825 12.3921L2.84084 11.678C3.04084 11.5783 3.20757 11.4316 3.32355 11.2534C3.43953 11.0751 3.50048 10.8719 3.5 10.6649V5.46735C3.50027 5.2306 3.5807 4.99963 3.73041 4.80568C3.88012 4.61173 4.09189 4.46414 4.33709 4.38288L9.04167 2.8408V1.66904C9.04112 1.30586 8.91018 0.952724 8.66863 0.663043C8.42709 0.373363 8.08809 0.162898 7.70292 0.0634838C7.53887 0.0208372 7.36899 -0.000535341 7.19834 2.26514e-06C6.87732 0.000548998 6.56189 0.0761639 6.2825 0.219543L0.898336 3.0048C0.6255 3.14579 0.398671 3.34975 0.240891 3.59597C0.0831112 3.84219 1.03252e-06 4.1219 2.97513e-06 4.40668V11.6436C-0.000406433 11.7909 0.0414449 11.9357 0.121445 12.0639C0.201446 12.1921 0.316844 12.2992 0.4563 12.3747C0.595757 12.4502 0.754476 12.4916 0.916863 12.4946C1.07925 12.4977 1.23972 12.4623 1.3825 12.3921Z",
    fill: "url(#paint1_linear_1023_48812)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04173 12.4953H3.47964C3.27419 12.4973 3.07513 12.5603 2.91297 12.6748C2.75081 12.7892 2.6345 12.9487 2.58187 13.1288C2.52924 13.3089 2.54319 13.4997 2.62159 13.6719C2.69998 13.8442 2.83849 13.9883 3.01589 14.0823L6.32923 15.7858C6.60213 15.9264 6.91073 16.0003 7.22464 16C7.39354 15.9999 7.56153 15.9776 7.72339 15.9339C8.10387 15.8358 8.43859 15.6277 8.67658 15.3412C8.91457 15.0547 9.0428 14.7055 9.04173 14.3468V12.4953Z",
    fill: "url(#paint2_linear_1023_48812)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3825 12.3921L2.84084 11.678C3.04084 11.5783 3.20757 11.4316 3.32355 11.2534C3.43953 11.0751 3.50048 10.8719 3.5 10.6649V5.46735C3.50027 5.2306 3.5807 4.99963 3.73041 4.80568C3.88012 4.61173 4.09189 4.46414 4.33709 4.38288L9.04167 2.8408V1.66904C9.04112 1.30586 8.91018 0.952724 8.66863 0.663043C8.42709 0.373363 8.08809 0.162898 7.70292 0.0634838C7.53887 0.0208372 7.36899 -0.000535341 7.19834 2.26514e-06C6.87732 0.000548998 6.56189 0.0761639 6.2825 0.219543L0.898336 3.0048C0.6255 3.14579 0.398671 3.34975 0.240891 3.59597C0.0831112 3.84219 1.03252e-06 4.1219 2.97513e-06 4.40668V11.6436C-0.000406433 11.7909 0.0414449 11.9357 0.121445 12.0639C0.201446 12.1921 0.316844 12.2992 0.4563 12.3747C0.595757 12.4502 0.754476 12.4916 0.916863 12.4946C1.07925 12.4977 1.23972 12.4623 1.3825 12.3921Z",
    fill: "url(#paint3_linear_1023_48812)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04173 12.4953H3.47964C3.27419 12.4973 3.07513 12.5603 2.91297 12.6748C2.75081 12.7892 2.6345 12.9487 2.58187 13.1288C2.52924 13.3089 2.54319 13.4997 2.62159 13.6719C2.69998 13.8442 2.83849 13.9883 3.01589 14.0823L6.32923 15.7858C6.60213 15.9264 6.91073 16.0003 7.22464 16C7.39354 15.9999 7.56153 15.9776 7.72339 15.9339C8.10387 15.8358 8.43859 15.6277 8.67658 15.3412C8.91457 15.0547 9.0428 14.7055 9.04173 14.3468V12.4953Z",
    fill: "url(#paint4_linear_1023_48812)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1023_48812",
    x1: 10.85,
    y1: -0.841128,
    x2: 10.85,
    y2: 14.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E25C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB4401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D83B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1023_48812",
    x1: 7.735,
    y1: -0.28831,
    x2: -0.254312,
    y2: 12.2913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C72127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C13959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#BC4B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B95799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B85BA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1023_48812",
    x1: 3.06256,
    y1: 14.249,
    x2: 15.0034,
    y2: 14.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A4070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1023_48812",
    x1: 7.92167,
    y1: -0.529011,
    x2: 6.23003,
    y2: 2.13415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1023_48812",
    x1: 11.1767,
    y1: 14.4923,
    x2: 5.83919,
    y2: 13.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_48812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOffice);
export default __webpack_public_path__ + "static/media/microsoftOffice.bb5aceb163d52f79a9530c13942a08ae.svg";
export { ForwardRef as ReactComponent };